export default __webpack_public_path__ + "static/media/000_background.56791d39.gif";